import { type Node, useReactFlow } from '@xyflow/react';
import type { FC } from 'react';
import { Fragment } from 'react';
import config from '@/app.config';
import useEmitter from '@/hooks/use-emitter';
import { AppEvent } from '@/types/event-emitter.types';
import { emitter } from '@/utils/event-emitter.ts';

export const FlowDelayedActions: FC = () => {
	const { setViewport, getNode } = useReactFlow();

	function waitForNode(cardId: string, callback: (node: Node) => void) {
		const interval = setInterval(() => {
			const node = getNode(cardId);

			if (node) {
				clearInterval(interval);
				callback(node);
			}
		}, 500);
	}
	useEmitter(AppEvent.SCROLL_TO_CARD, ({ cardId }) => {
		waitForNode(cardId, (node) => {
			const zoom = 0.6;
			const width = config.view.extended.flowCard.width;
			const height = config.view.extended.flowCard.height;
			const viewportWidth = window.innerWidth;
			const viewportHeight = window.innerHeight;

			const nodeCenterX = node.position.x + width / 2;
			const nodeCenterY = node.position.y + height / 2;
			const targetScreenX = viewportWidth * 0.4;
			const targetScreenY = viewportHeight * 0.5;

			setViewport(
				{
					x: targetScreenX - nodeCenterX * zoom,
					y: targetScreenY - nodeCenterY * zoom,
					zoom
				},
				{ duration: 500 }
			);
			emitter.emit(AppEvent.COLLAPSE_EXPAND_CARD, {
				cardId,
				isCollapsed: true
			});
			emitter.emit(AppEvent.ANIMATE_CLONED_FLOW_CARD, { cardId });
		});
	});

	return <Fragment />;
};
